<template>
  <form v-if="rsvpConfigsToSave" class="c-rsvp-config__body">
    <div class="columns is-multiline">
      <div class="column is-full">
        <span class="title-form">Preferências</span>
      </div>
      <div class="column is-full pt-5">
        <div class="field">
          <div class="control" autocomplete="off">
            <b-field
              :type="{
                'is-danger': validation.hasError(
                  'rsvpConfigsToSave.page_title'
                ),
              }"
              :message="{
                'Preenchimento obrigatório': validation.hasError(
                  'rsvpConfigsToSave.page_title'
                ),
              }"
              class="form-field"
            >
              <b-input
                v-model="rsvpConfigsToSave.page_title"
                @change.native="saveRsvpConfigs"
                class="has-value"
                name="title"
                type="text"
                maxlength="50"
                :has-counter="false"
              />
            </b-field>
            <label for="title" class="label">Título:</label>
          </div>
        </div>
      </div>

      <div class="column is-full pt-5">
        <div class="field">
          <div class="control" autocomplete="off">
            <textarea
              rows="2"
              ref="FocusOnError"
              v-model="rsvpConfigsToSave.page_introduction"
              class="input has-value outlined-field"
              @change="saveRsvpConfigs"
              type="text"
              name="intro"
              maxlength="800"
              placeholder="Escreva aqui uma introdução"
            />
            <label for="intro" class="label has-text-left"
              >Introdução (opcional)</label
            >
          </div>
        </div>
      </div>

      <div class="column is-full">
        <div class="field">
          <div class="control outlined-body" autocomplete="off">
            <div class="is-flex is-align-items-center label-group">
              <tag-icon icon="painel/child-icon" class="mr-4" />
              <p
                for="childrenAge"
                class="has-text-weight-bold has-space-bottom"
              >
                Informar idade máxima para crianças
              </p>
            </div>
            <div class="input input-select">
              <b-select
                @change.native="saveRsvpConfigs"
                name="childrenAge"
                v-model="rsvpConfigsToSave.preferences.closed.minimum_age_child"
              >
                <option selected value="0" class="select-items">
                  Prefiro não informar
                </option>
                <option
                  v-for="item in maxAgeChildren"
                  :key="item"
                  :value="item"
                  class="select-items"
                  name="childrenAge"
                >
                  {{ item }}
                </option>
              </b-select>
            </div>
          </div>
        </div>
      </div>

      <div class="column is-full">
        <div class="control form-switch outlined-body">
          <div class="is-flex is-align-items-center label-group">
            <tag-icon icon="painel/message-icon" class="mr-4" />
            <p for="check-obs" class="has-text-weight-bold">
              Incluir campo aberto de observação para o convidado inserir
              comentários extras
            </p>
          </div>
          <div>
            <b-switch
              id="check-obs"
              v-model="rsvpConfigsToSave.preferences.closed.show_obs"
              @change.native="saveRsvpConfigs"
            />
          </div>
        </div>
      </div>

      <div class="column is-full">
        <div class="control form-switch outlined-body">
          <div class="is-flex is-align-items-center label-group">
            <tag-icon icon="painel/checklist-icon" class="mr-4" />

            <p for="check-all-invites" class="has-text-weight-bold is-flex">
              <span
                >Permitir que meus convidados vejam a lista completa de
                convites</span
              >
              <span
                data-tooltip="Caso o convidado não encontre o convite pelo nome, permitiremos que ele veja a lista completa de convites cadastrados, identificando-os pelo nome do convite e os quatro primeiros dígitos do celular cadastrado."
                class="tooltip tooltip-check-all-invites is-tooltip-left is-tooltip-top-tablet is-tooltip-multiline is-inline-flex ml-4 block"
              >
                <base-icon
                  class="icon"
                  width="24px"
                  height="24px"
                  name="painel/filled-info-icon"
                />
              </span>
            </p>
          </div>
          <div>
            <b-switch
              id="check-all-invites"
              @change.native="saveRsvpConfigs"
              v-model="rsvpConfigsToSave.preferences.closed.show_all_invites"
            />
          </div>
        </div>
      </div>
      <div class="column is-full">
        <div class="control card-invite">
          <p>Gerenciar convidados</p>

          <router-link
            class="button-create-invite"
            :to="{ path: `/rsvp/cadastrar-convites` }"
          >
            <base-icon
              class="icon"
              width="24px"
              height="24px"
              name="painel/plus-circle"
            />
            Cadastrar convites
          </router-link>
        </div>
      </div>
    </div>

    <ModalCreateRsvpInvites ref="modalRegisterInvites" />
  </form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import SimpleVueValidator from 'simple-vue-validator'
import TagIcon from './TagIcon.vue'
import ModalCreateRsvpInvites from './Modals/ModalCreateRsvpInvites.vue'

import RsvpApi from '@/lib/api/Rsvp'

const Validator = SimpleVueValidator.Validator

export default {
  mixins: [SimpleVueValidator.mixin],

  components: {
    TagIcon,
    ModalCreateRsvpInvites,
  },

  validators: {
    'rsvpConfigsToSave.page_title': (value) => {
      return Validator.value(value).required()
    },
  },

  computed: {
    ...mapGetters({
      logonToken: 'app/logonToken',
      wedSiteInfo: 'app/getWedSiteInfo',
      rsvpConfigs: 'getRsvpConfigs',
    }),
  },

  data() {
    return {
      maxAdults: 10,
      maxChildren: 10,
      maxAgeChildren: 18,
      rsvpConfigsToSave: undefined,
      configsInitialJsonCopy: undefined,
    }
  },

  watch: {
    rsvpConfigs(payload) {
      this.rsvpConfigsToSave = payload
    },
  },
  mounted() {
    this.rsvpConfigsToSave = {
      ...this.rsvpConfigs,
      mode: 'closed',
    }
    this.configsInitialJsonCopy = JSON.stringify(this.rsvpConfigs)
  },

  methods: {
    ...mapActions({
      notification: 'app/setNotification',
      setSaving: 'gifts/setSaving',
      setRsvpConfigs: 'setRsvpConfigs',
    }),

    handleBeforeUnload(event) {
      event.preventDefault()
      event.returnValue = ''
    },

    saveRsvpConfigs() {
      if (this.rsvpConfigsToSave.page_title && this.hasChanges()) {
        this.setSaving(true)

        const rsvpApi = new RsvpApi(this.logonToken)
        rsvpApi
          .setConfigRsvp(this.rsvpConfigsToSave)
          .then((response) => {
            if (response.status === 201) {
              this.setRsvpConfigs(this.rsvpConfigsToSave)
              this.configsInitialJsonCopy = JSON.stringify(
                this.rsvpConfigsToSave
              )
              this.notification({
                message: 'Configurações salvas com sucesso!',
                show: true,
              })
            }
          })
          .catch(() => {
            this.notification({
              message: 'Erro no salvamento. Por favor, tente novamente.',
              show: true,
              class: 'is-error',
            })
          })
          .finally(() => {
            this.setSaving(false)
          })
      }
    },

    hasChanges() {
      return (
        this.configsInitialJsonCopy !== JSON.stringify(this.rsvpConfigsToSave)
      )
    },
  },
}
</script>
<style scoped lang="scss">
.tooltip-check-all-invites {
  position: absolute;
  z-index: 1;
  top: 16px;
  right: 22px;
  bottom: auto;
  left: auto;
  @media screen and (min-width: $tablet) {
    position: relative;
    top: auto;
    right: auto;
  }
}

.card-invite {
  border-radius: 16px;
  background: $neutrallightest;
  padding: 32px;
  gap: 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  p {
    color: $neutral;
    font-size: 20px;
    font-weight: 700;
    line-height: 100%; /* 20px */
  }
  .button-create-invite {
    .icon {
      color: $support;
    }
    border-radius: 16px;
    border: 1px solid #dde7f1;
    max-width: 412px;
    background: #fff;
    cursor: pointer;
    display: flex;
    padding: 24px;
    color: $neutral !important;
    text-decoration: none;
    align-items: center;
    gap: 16px;
    &:hover {
      border-radius: 16px;
      border: 1px solid #d9e2eb;
      background: white;
      box-shadow: 0px 10px 8px 0px rgba(93, 117, 141, 0.05);
    }
  }
}
</style>
